<div class="affiliate_page_wrap">
    <div class="affiliate_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="affi_top_contents">
                        <h1>推广Trinka赚大钱！</h1>
                        <a id="signUpAtShareASale" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            在 ShareASale 上注册
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="benefits_sections">
        <div class="benefits_outer">
            <div class="commission_sections">
                <div class="commission_header">
                    <img src="assets/images/CommisionDetails.png" alt="">
                    <h2>佣金详情</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <!-- <li>免费注册-  $0.30</li> -->
                        <li>付费订阅计划 -  25%</li>
                    </ul>
                </div>
            </div>

            <div class="commission_sections OtherBenefits_section">
                <div class="commission_header">
                    <img src="assets/images/otherBenefits.png" alt="">
                    <h2>其他福利</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <li>高转化率 (20-25%)</li>
                            <li>跨设备追踪</li>
                            <li>延长90天的cookie窗口</li>
                            <li>早期加入奖励</li>
                            <li>顶级伙伴支持</li>
                    </ul>
                </div>
            </div>

        </div>
        <!-- <div class="container">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Commision Details</h2>
                        <ul>
                            <li>Free Sign-ups - $0.21</li>
                            <li>Paid plan subscription - $20</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Other Benefits</h2>
                        <ul>
                            <li>Great conversion rates (20-30%)</li>
                            <li>Cross-device tracking</li>
                            <li>Extended 90-day cookie window</li>
                            <li>Early bird rewards</li>
                            <li>Top-class affiliate support</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div> -->
    </div>


    <div class="why_become_affiliate_sectioin">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <h2>为什么要加入联盟营销？</h2>
                    <div class="HeadingSubLine"></div>
                    <p>语法和文句更正是一项艰巨的任务，大多数在线语法检查工具在学术和技术写作方面都会遇到各种困难。Trinka利用人工智能和机器学习技术以及数十年的行业专业知识，为作者提供撰写无错误技术或学术论文所需的建议。Trinka是免费工具，可以在线使用，并且有浏览器插件和 MS Word 插件。</p>
                    <p>通过与Trinka合作，您不仅可以帮助学术专业人士和机构，还可以用少许的努力获得稳定的收入。Trinka将帮助您处理所有繁重的工作，让您继续专注于自己最擅长的事，并通过向作者提供最新和有用的内容和建议来维护客户关系。</p>
                </div>
                <div class="col-md-3">
                    <div class="affiliate_img">
                        <img src="assets/images/anAffiliate.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="Affiliate_FAQ_Seciton">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="faq_affiliate_sections">
                        <h2>联盟营销常见问题解答</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header" id="heading-1">
                                <h5 class="mb-0">
                                    <a role="button" data-toggle="collapse" href="#collapse-1" aria-expanded="true"
                                        aria-controls="collapse-1">
                                        关于Trinka联盟营销计划
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-1" class="collapse show" data-parent="#accordion"
                                aria-labelledby="heading-1">
                                <div class="card-body">
                                    <p>Trinka联盟营销计划以简单高效的方式运作——您可以在网站或社交媒体、电子邮件、电子书等，放置横幅或跟踪文本链接。每次推荐用户注册Trinka时，您都可以获得报酬。由于Trinka是免费的，您不需要过度销售宣传都可以得到收入。如实宣传，加入链接就可以了，但当然业绩更好的联盟营销伙伴能够得到更高的报酬。</p>
                                    <p>如有任何疑问，请发送电子邮件至<a
                                            href="mailto:marketing@trinka.ai.">marketing@trinka.ai</a>。</p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="heading-2">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-2"
                                        aria-expanded="false" aria-controls="collapse-2">
                                        谁可以成为Trinka联盟营销伙伴？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-2" class="collapse" data-parent="#accordion" aria-labelledby="heading-2">
                                <div class="card-body">
                                    <p>Trinka能帮助世界各地的学生、研究人员、科学家、专业人士、语言爱好者以及所有用英语写作的人。Trinka 的联盟营销计划与写作相关的网站或博客完美契合。此外我们还有一些积极的联盟营销伙伴，其内容强调教育、科学、技术、职业发展，以及吸引Trinka多元化用户群的众多其他领域。</p>
                                    <p>您可以通过创建与我们使命同步的内容并确保其相关性、结构合理和最新性，从而最大限度地利用我们联盟营销计划带来的好处。</p>
                                        
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-3">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-3"
                                        aria-expanded="false" aria-controls="collapse-3">
                                        我怎样才能成为Trinka的联盟营销伙伴？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-3" class="collapse" data-parent="#accordion" aria-labelledby="heading-3">
                                <div class="card-body">
                                    <p>一旦您被接受加入该计划，您将获得一系列的附属横幅和链接。如果您愿意，您可以使用即时通讯软件和电子邮件来宣传Trinka。</p>
                                    <p>当放置我们提供的横幅或链接时，请确保您将其添加到最有价值和合适内容的页面中。为了得到最好的用户体验，请不要将链接和横幅放置在其他横幅或链接旁边。</p>
                                    <p>请不要为客户提供加入Trinka的奖励。</p>
                                    <p>此外，避免对商标“Trinka”或“Trinka.ai”或其任何变体（包括不正确的拼写）进行竞标。请避免在域名或元标签中使用这些商标名称，也不要从按点击付费的广告中直接链接到我们的网站。</p>
                                    <p style="margin: 0;">最后，我们禁止对下列品牌和非品牌关键词进行投标：</p>
                                    <p>Trinka，Trinka AI，Trinka.AI，www.Trinka.AI，剽窃检查，语法检查，剽窃检查，免费剽窃检查，免费语法检查，在线语法检查，写作助手，学术写作助手，技术写作助手，校对。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-4">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-4"
                                        aria-expanded="false" aria-controls="collapse-4">
                                        成为联盟营销伙伴有什么好处？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-4" class="collapse" data-parent="#accordion" aria-labelledby="heading-4">
                                <div class="card-body">
                                    <p>每一次用户付费升级时，会支付您25%的佣金。您网站上的每个连结都有一个特定的跟踪代码，每次客户通过您的网站点击trinka.ai并安装免费的Trinka浏览器扩展、注册或升级到付费计划，我们会记录这些转化并将收益分配到您的账户。您可以随时从操作接口或ShareASale的报告部分查看您的转化和收入。由于cookie政策延长至90天，用户若在首次访问网站后90天内付费升级，就会计入您的佣金。</p>
                                        <p>请注意所有付款将仅以美元支付。如果您不在美国，请确保您的银行账号能够接收美元转账。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-5">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-5"
                                        aria-expanded="false" aria-controls="collapse-5">
                                        Trinka 联盟营销计划的条款和条件是什么？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-5" class="collapse" data-parent="#accordion" aria-labelledby="heading-5">
                                <div class="card-body">
                                    <p>请访问 <a href="https://www.trinka.ai/termsofservices/"
                                            target="_blank">此链接</a> 阅读我们的条款和条件。</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div class="bottom_shareAsale_buttons">
                        <a id="signUpAtShareASaleFooter" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            在 ShareASale 上注册
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>